import { sum } from 'ramda'
import { IStatisticalByDeviceType } from './device.types'

export const sumCountByDeviceType = (
  statistical: IStatisticalByDeviceType[],
  key: keyof IStatisticalByDeviceType,
  deviceType: string
) => {
  return sum(
    statistical
      ?.filter(item => item?.deviceType === deviceType)
      .map(item => (typeof item[key] === 'number' ? item[key] : 0))
  )
}

export const sumStatisticalCountByDeviceType = (
  statistical: IStatisticalByDeviceType[],
  deviceType: string
) => {
  return {
    deviceCount: sumCountByDeviceType(statistical, 'deviceCount', deviceType),
    summaryChargingCount: sumCountByDeviceType(
      statistical,
      'summaryChargingCount',
      deviceType
    ),
    summaryUnavailableCount: sumCountByDeviceType(
      statistical,
      'summaryUnavailableCount',
      deviceType
    ),
    summaryAvailableCount: sumCountByDeviceType(
      statistical,
      'summaryAvailableCount',
      deviceType
    ),
    connectorCount: sumCountByDeviceType(
      statistical,
      'connectorCount',
      deviceType
    ),
    availableCount: sumCountByDeviceType(
      statistical,
      'availableCount',
      deviceType
    ),
    chargingCount: sumCountByDeviceType(
      statistical,
      'chargingCount',
      deviceType
    ),
    deviceAlarmCount: sumCountByDeviceType(
      statistical,
      'deviceAlarmCount',
      deviceType
    ),
    deviceNormalCount: sumCountByDeviceType(
      statistical,
      'deviceNormalCount',
      deviceType
    ),
    deviceRepairCount: sumCountByDeviceType(
      statistical,
      'deviceRepairCount',
      deviceType
    ),
    faultedCount: sumCountByDeviceType(statistical, 'faultedCount', deviceType),
    finishingCount: sumCountByDeviceType(
      statistical,
      'finishingCount',
      deviceType
    ),
    preparingCount: sumCountByDeviceType(
      statistical,
      'preparingCount',
      deviceType
    ),
    reservedCount: sumCountByDeviceType(
      statistical,
      'reservedCount',
      deviceType
    ),
  }
}
